import { literal, partial, union } from 'io-ts/Decoder';

export const Query = partial({
	download: union(literal('true'), literal('false')),
});
